import { useId, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, FormField, Input, Modal } from '@ntconsult/aluma-react';
import { useCreateFolder } from '../hooks/useCreateFolder';

interface CreateFolderModalProps {
  isOpen: boolean;
  onClose: () => void;
  parentId?: string;
}

export function CreateFolderModal({ isOpen, onClose, parentId }: CreateFolderModalProps) {
  const { t } = useTranslation(['folders', 'common']);
  const titleId = useId();
  const formId = useId();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const { mutate: createFolder, isPending } = useCreateFolder();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    createFolder(
      { name, description: description || undefined, parentId },
      {
        onSuccess: () => {
          setName('');
          setDescription('');
          onClose();
        },
      }
    );
  };

  return (
    <Modal open={isOpen} onClose={onClose} ariaLabelledBy={titleId} size="sm">
      <Modal.Header titleId={titleId} title={t('folders:newFolder')} onClose={onClose} />
      <Modal.Body>
        <form id={formId} onSubmit={handleSubmit} className="flex flex-col gap-4">
          <FormField label={t('folders:folderName')} required>
            <Input
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder={t('folders:folderNamePlaceholder')}
              autoFocus
            />
          </FormField>
          <FormField label={t('folders:description')}>
            <Input
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder={t('folders:descriptionPlaceholder')}
            />
          </FormField>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button type="button" variant="ghost" onClick={onClose} disabled={isPending}>
          {t('common:actions.cancel')}
        </Button>
        <Button type="submit" form={formId} variant="primary" loading={isPending}>
          {t('folders:createFolder')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
